import React from "react";
import { RootStoreState } from "./types";
import { RootStoreContext } from "./RootStore";

export function useRootStore(): RootStoreState {
  const ctx = React.useContext(RootStoreContext);
  if (!ctx) {
    throw new Error("useRootStore must be used within RootStoreContext");
  }

  return ctx;
}
